import {EstabInstalacaoModel, IEstabInstalacao} from './estab-instalacao.model';
import {EstabLeitoModel, IEstabLeito} from './estab-leito.model';
import {EstabEquipamentoModel, EstabEquipamentoSaveModel, IEstabEquipamento} from './estab-equipamento.model';
import {Guid} from 'guid-typescript';
import {FiltroBuscaGridModel, ResultadoBuscaGridModel} from '../classes-filtro-busca-grid';

export class RecursoFisicoModulo {
    instalacoes: EstabInstalacaoModel[];
    leitos: EstabLeitoModel[];
    equipamentos: EstabEquipamentoModel[];
    equipamento: EstabEquipamentoSaveModel;

    constructor() {
        this.instalacoes = [];
        this.leitos = [];
        this.equipamentos = [];
        this.equipamento = null;
    }

    rascunhoParaRecursoFisico(rascunho: any) {
        this.rascunhoParaEquipamentos(rascunho);
        this.rascunhoParaLeitos(rascunho);
        this.rascunhoParaInstalacoes(rascunho);
    }

    async buscarInstalacoes(filtros: FiltroBuscaGridModel): Promise<ResultadoBuscaGridModel> {
        let listaOriginal: EstabInstalacaoModel[] = [];
        if (this.instalacoes && this.instalacoes.length) {
            if (filtros.textoBuscaTextual.length > 1) {
                listaOriginal = await this.instalacoes.filter(p =>
                    p.instalacao.toLowerCase().includes(filtros.textoBuscaTextual.toLowerCase()) ||
                    p.tipo.toLowerCase().includes(filtros.textoBuscaTextual.toLowerCase()) ||
                    p.subTipo.toLowerCase().includes(filtros.textoBuscaTextual.toLowerCase()) ||
                    p.idInstalacao.includes(filtros.textoBuscaTextual)
                );
            } else {
                listaOriginal = this.instalacoes;
            }
        }
        return new ResultadoBuscaGridModel(filtros, listaOriginal);
    }

    async buscarLeitos(filtros: FiltroBuscaGridModel): Promise<ResultadoBuscaGridModel> {
        let listaOriginal: EstabLeitoModel[] = [];
        if (this.leitos && this.leitos.length) {
            if (filtros.textoBuscaTextual.length > 1) {
                listaOriginal = this.leitos.filter(p =>
                    p.detalhamento.toLowerCase().includes(filtros.textoBuscaTextual.toLowerCase()) ||
                    p.tipo.toLowerCase().includes(filtros.textoBuscaTextual.toLowerCase()) ||
                    p.quantidadeAtivo.toString().includes(filtros.textoBuscaTextual.toLowerCase()) ||
                    p.quantidadeNoSus.toString().includes(filtros.textoBuscaTextual)
                );
            } else {
                listaOriginal = this.leitos;
            }
        }
        return new ResultadoBuscaGridModel(filtros, listaOriginal);
    }

    async buscarEquipamentos(filtros: FiltroBuscaGridModel): Promise<ResultadoBuscaGridModel> {
        let listaOriginal: EstabEquipamentoModel[] = [];
        if (this.equipamentos && this.equipamentos.length) {
            if (filtros.textoBuscaTextual.length > 1) {
                listaOriginal = this.equipamentos.filter(p =>
                    p.equipamento.toLowerCase().includes(filtros.textoBuscaTextual.toLowerCase()) ||
                    p.tipoEquipamento.toLowerCase().includes(filtros.textoBuscaTextual.toLowerCase()) ||
                    p.quantidadeExistente.toString().includes(filtros.textoBuscaTextual.toLowerCase()) ||
                    p.sus.toString().includes(filtros.textoBuscaTextual)
                );
            } else {
                listaOriginal = this.equipamentos;
            }
        }
        return new ResultadoBuscaGridModel(filtros, listaOriginal);
    }

    async salvarInstalacao(instalacao: EstabInstalacaoModel) {
        const novaInstalacao = new EstabInstalacaoModel(instalacao);
        novaInstalacao.id = Guid.create().toString();
        this.instalacoes.push(novaInstalacao);
    }

    async editarInstalacao(instalacao: EstabInstalacaoModel) {
        const indice = this.instalacoes.findIndex(objFind => objFind.id === instalacao.id);
        this.instalacoes[indice] = instalacao;
    }

    async excluirInstalacao(instalacao: EstabInstalacaoModel) {
        const indice = this.instalacoes.findIndex(objFind => objFind.id === instalacao.id);
        this.instalacoes.splice(indice, 1);
    }

    async salvarEquipamento(equipamento: EstabEquipamentoModel) {
        const novoEquipamento = new EstabEquipamentoModel(equipamento);
        novoEquipamento.id = Guid.create().toString();
        this.equipamentos.push(novoEquipamento);
    }

    async editarEquipamento(equipamento: EstabEquipamentoModel) {
        const indice = this.equipamentos.findIndex(objFind => objFind.id === equipamento.id);
        this.equipamentos[indice] = equipamento;
    }

    async excluirEquipamento(equipamento: EstabEquipamentoModel) {
        const indice = this.equipamentos.findIndex(objFind => objFind.id === equipamento.id);
        this.equipamentos.splice(indice, 1);
    }

    async salvarLeito(leito: EstabLeitoModel) {
        const novoLeito = new EstabLeitoModel(leito);
        novoLeito.id = Guid.create().toString();
        this.leitos.push(novoLeito);
    }

    async editarLeito(leito: EstabLeitoModel) {
        const indice = this.leitos.findIndex(objFind => objFind.id === leito.id);
        this.leitos[indice] = leito;
    }

    async excluirLeito(leito: EstabLeitoModel) {
        const indice = this.leitos.findIndex(objFind => objFind.id === leito.id);
        this.leitos.splice(indice, 1);
    }

    /*EstabEquipamentoModel
    equipamento: "emissoes otoacusticas evocadas por produto de distorcao"
    equipamentoObj: {}
    id: "6ed235d8-fe8e-f324-5e78-3c2dea0fa496"
    idEquipamento: "88"
    idTipoEquipamento: "8"
    quantidadeExistente: "15"
    quantidadeUso: 0
    sus: 0
    tipoEquipamento: "EQUIPAMENTOS DE AUDIOLOGIA"*/

    private rascunhoParaEquipamentos(rascunho: any) {
        if (rascunho.recursoFisico && rascunho.recursoFisico.equipamentos) {
            rascunho.recursoFisico.equipamentos.forEach((item) => {
                const equipamento: IEstabEquipamento = {
                    id: Guid.create().toString(),
                    idTipoEquipamento: item.equipamento ? item.idTipoEquipamento : null,
                    tipoEquipamento: item.equipamento, // TODO Descrição Tipo Equipamento (Equipamento)
                    idEquipamento: item.equipamento ? item.idEquipamento : null,
                    equipamento: item.equipamento ? item.equipamento : null,
                    equipamentoObj: item.equipamentoObj,
                    quantidadeExistente: item.quantidadeExistente ? Number(item.quantidadeExistente) : 0,
                    quantidadeUso: item.quantidadeEmUso ? Number(item.quantidadeEmUso) : 0,
                    sus: item.sus ? Number(item.sus) : 0,
                };
                this.equipamentos.push(new EstabEquipamentoModel(equipamento));
            });
        }
    }

    private rascunhoParaLeitos(rascunho: any) {
        if (rascunho.leitos && rascunho.leitos.length > 0) {
            rascunho.leitos.forEach((item) => {
                const leito: IEstabLeito = {
                    id: Guid.create().toString(),
                    idTipo: item.leito ? item.leito.tipoLeito : '',
                    tipo: item.leito ? item.leito.descricao : '',
                    codigoLeito: item.leito ? item.leito.tipoLeito : '', // TODO ID Detalhamento (Leito)
                    detalhamento: null, // TODO Descricao Detalhamento (Leito)
                    quantidadeAtivo: item.quantidadeExistente ? Number(item.quantidadeExistente) : 0,
                    leitoObj: item.leito,
                    quantidadeNoSus: item.quantidadeNoSus ? Number(item.quantidadeNoSus) : 0,
                    quantidadeHabilitados: item.quantidadeHabilitados ? Number(item.quantidadeHabilitados) : 0,
                    competenciaFinal: item.competenciaFinal,
                    competenciaInicial: item.competenciaInicial,
                };
                this.leitos.push(new EstabLeitoModel(leito));
            });
        }
    }

    private rascunhoParaInstalacoes(rascunho: any) {
        if (rascunho.instalacoes && rascunho.instalacoes.length > 0) {
            rascunho.instalacoes.forEach((item) => {
                const instalacao: IEstabInstalacao = {
                    id: Guid.create().toString(),
                    idTipo: null, // TODO Codigo Tipo (Instalação)
                    tipo: null, // TODO Descricao Tipo (Instalação)
                    idSubTipo: item.instalacao ? item.instalacao.subTipoInstalacao : '',
                    subTipo: null, // TODO Descricao SubTipo (Instalação)
                    idInstalacao: item.instalacao ? item.instalacao.codigo : '',
                    instalacao: item.instalacao ? item.instalacao.descricao : '',
                    instalacaoObj: item.instalacao,
                    quantidadeInstalacoes: item.quantidadeInstalacoes ? Number(item.quantidadeInstalacoes) : 0,
                    quantidadeLeitos: item.quantidadeLeitos ? Number(item.quantidadeLeitos) : 0,
                };
                this.instalacoes.push(new EstabInstalacaoModel(instalacao));
            });
        }
    }
}
